"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.actions = exports.SessionAccountItem = exports.MenuSection = exports.AddAccountSection = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _styles = require("@material-ui/core/styles");
var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));
var _Avatar = _interopRequireDefault(require("../Avatar"));
var _hover = require("../../hooks/hover");
var _excluded = ["options", "children"],
  _excluded2 = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = (0, _styles.makeStyles)({
  paper: {
    boxShadow: '0px 5px 20px rgba(0, 0, 0, .1)'
  }
});
var AccountMenu = function AccountMenu(_ref, outerRef) {
  var open = _ref.open,
    avatar = _ref.avatar,
    children = _ref.children,
    onToggle = _ref.onToggle;
  var classes = useStyles();
  var ref = (0, _react.useRef)(null);
  (0, _react.useImperativeHandle)(outerRef, function () {
    return ref.current;
  }, [ref.current]);
  var count = _react["default"].Children.count(children);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: "inline-block mx-1 rounded-full shadow cursor-pointer select-none hover:shadow-lg dark:hover:shadow-shallow",
    onClick: onToggle
  }, avatar), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    open: open,
    className: "mt-3",
    classes: classes,
    onClose: onToggle,
    anchorEl: ref.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '20rem'
    }
  }, _react["default"].Children.map(children, function (node, index) {
    return node && /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: (0, _classnames["default"])({
        'border-b': index !== count - 1
      })
    }, node);
  }))));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(AccountMenu);
var MenuSection = exports.MenuSection = function MenuSection(_ref2) {
  var _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? [] : _ref2$options,
    children = _ref2.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-2"
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    className: "overflow-auto"
  }), children, options.map(function (_ref3, index) {
    var title = _ref3.title,
      action = _ref3.action,
      _onClick = _ref3.onClick;
    return /*#__PURE__*/_react["default"].createElement(MenuItem, {
      key: index,
      onClick: function onClick() {
        if (_onClick) {
          _onClick();
        }
      }
    }, /*#__PURE__*/_react["default"].createElement("span", null, title), action);
  })));
};
var MenuItem = function MenuItem(_ref4) {
  var children = _ref4.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    className: "h-12 p-3 flex items-center justify-between text-xs text-gray-medium cursor-pointer hover:bg-secondary"
  }), children);
};
var SessionAccountItem = exports.SessionAccountItem = function SessionAccountItem(_ref5) {
  var name = _ref5.name,
    email = _ref5.email,
    avatar = _ref5.avatar,
    isActive = _ref5.isActive,
    onClick = _ref5.onClick,
    hoverable = _ref5.hoverable,
    hoverAction = _ref5.hoverAction,
    _ref5$isLoading = _ref5.isLoading,
    isLoading = _ref5$isLoading === void 0 ? false : _ref5$isLoading,
    _ref5$validSession = _ref5.validSession,
    validSession = _ref5$validSession === void 0 ? false : _ref5$validSession,
    _ref5$importAccountsC = _ref5.importAccountsCount,
    importAccountsCount = _ref5$importAccountsC === void 0 ? 0 : _ref5$importAccountsC;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useHover = (0, _hover.useHover)(),
    hovered = _useHover.hovered,
    targetProps = _useHover.targetProps;
  var isInvalid = !validSession && isLoading;
  var isHoverable = hoverable && !isLoading;
  var isClickable = !!onClick && !isLoading;
  var emailNode = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "truncate"
    }, email), importAccountsCount > 0 && /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-light ml-1"
    }, "+".concat(importAccountsCount)));
  }, [email, importAccountsCount]);
  var props = (0, _react.useMemo)(function () {
    var props = _objectSpread(_objectSpread({}, isHoverable ? targetProps : {}), {}, {
      onClick: isClickable ? onClick : undefined
    });
    return props;
  }, [targetProps, onClick, isHoverable, isClickable]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])('relative h-20', {
      'bg-secondary': isActive,
      'cursor-pointer': isClickable,
      'hover:bg-secondary': isHoverable
    })
  }), isLoading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute w-full inset-0 overflow-hidden",
    style: {
      height: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_LinearProgress["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex items-center justify-between h-full', {
      'opacity-50 gray-filter': isInvalid
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-3 py-2"
  }, avatar), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('py-2 min-w-0 flex-1', {
      'pr-3': !hovered || isActive
    })
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm font-bold truncate break-all"
  }, name), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-xs text-gray-medium"
  }, emailNode), !validSession && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-xs text-gray-light italic"
  }, t('menu.sessionExpired'))), hovered && /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, hoverAction)));
};
var actions = exports.actions = {
  Logout: function Logout(props) {
    var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;
    return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
      className: "text-primary hover:text-primary-active font-bold text-sm px-3"
    }), t('menu.logout'));
  },
  Login: function Login(props) {
    var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;
    return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
      className: "text-primary hover:text-primary-active font-bold text-sm px-3"
    }), t('menu.login'));
  }
};
var AddAccountSection = exports.AddAccountSection = function AddAccountSection(_ref6) {
  var _ref6$enableRetrofitA = _ref6.enableRetrofitAccounts,
    enableRetrofitAccounts = _ref6$enableRetrofitA === void 0 ? false : _ref6$enableRetrofitA,
    onClick = _ref6.onClick;
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  var avatar = (0, _react.useMemo)(function () {
    if (enableRetrofitAccounts) {
      return /*#__PURE__*/_react["default"].createElement("img", {
        width: "250",
        height: "250",
        src: t('onmail-import-account-icon.png'),
        alt: "import-account",
        className: "w-16 h-16"
      });
    } else {
      return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
        src: t('onmail-avatar.png'),
        alt: "onmail-avatar"
      });
    }
  }, [enableRetrofitAccounts]);
  return /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClick,
    className: "flex items-center justify-between w-full hover:bg-secondary py-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      'px-1': enableRetrofitAccounts,
      'px-3 py-2': !enableRetrofitAccounts
    })
  }, avatar), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-2 min-w-0 flex-1 text-left"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm font-bold truncate break-all"
  }, t('multipleSession.addAccount.title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-xs truncate text-gray-medium break-all"
  }, t('multipleSession.addAccount.subtitle'))));
};
//# sourceMappingURL=index.js.map